import { Injectable, inject } from '@angular/core';
import { ThemesHelperService } from '../themes-helper/themes-helper.service';

interface FieldConfig {
  [key: string]: string[];
}

/**
 * PaymentSettingsService (Angular 18)
 *
 * Replaces: apps/b2b-ui/common/services/paymentSettings/paymentSettings.service.js
 * Manages payment field display and validation configuration.
 * Depends on ThemesHelperService for CC validation settings.
 */
@Injectable({ providedIn: 'root' })
export class PaymentSettingsService {
  private themesHelper = inject(ThemesHelperService);

  displayFields: FieldConfig = {
    address: [],
    zipcode: [],
    none: [],
  };

  validationFields: FieldConfig = {
    address: [],
    zipcode: [],
    none: [],
  };

  settings: any = {};

  constructor() {
    this.settings = this.themesHelper.getCCValidationSettings();
  }

  // ─── Initialization ───────────────────────────────────────────────────────

  init(): boolean {
    return true;
  }

  // ─── Field configuration ──────────────────────────────────────────────────

  /**
   * Check if a field matches a property configuration.
   * Supports 'address', 'zipcode', and 'none' properties.
   */
  checkFieldProperties(property: string, field: string): boolean {
    if (property === 'address') {
      switch (field) {
        case 'address-create-country-select':
        case 'address-create-country-input':
        case 'address-create-state-select':
        case 'address-create-state-input':
        case 'country':
        case 'otherCountry':
        case 'streetAddress1':
        case 'streetAddress2':
        case 'address1':
        case 'address2':
        case 'city':
        case 'state':
        case 'otherState':
        case 'zip':
        case 'zipCode':
          return true;
      }
    } else if (property === 'zipcode') {
      switch (field) {
        case 'zip':
        case 'zipCode':
          return true;
      }
    } else if (property === 'none') {
      if (field === 'none') {
        return true;
      }
    }

    return false;
  }

  // ─── Validation ───────────────────────────────────────────────────────────

  /**
   * Check if a field should be validated based on settings.
   */
  checkFieldValidation(name: string): boolean {
    let validation = 'none';

    if (Object.prototype.hasOwnProperty.call(this.settings, 'b2bValidation')) {
      validation = (this.settings.b2bValidation as string).toLowerCase();
    }

    console.log('PaymentSettingsService::checkFieldValidation', validation, name);

    return this.checkFieldProperties(validation, name);
  }

  // ─── Display ──────────────────────────────────────────────────────────────

  /**
   * Check if a field should be displayed based on settings.
   */
  checkFieldDisplay(name: string): boolean {
    let display = 'address';

    if (Object.prototype.hasOwnProperty.call(this.settings, 'b2bDisplay')) {
      display = (this.settings.b2bDisplay as string).toLowerCase();
    }

    console.log('PaymentSettingsService::checkFieldDisplay', display, name);

    return this.checkFieldProperties(display, name);
  }
}
